// extracted by mini-css-extract-plugin
export var container = "_ak-0";
export var icon = "_ak-1";
export var text = "_ak-2";